import React from 'react'
import ReactDOM from 'react-dom'
import reducers, {initialState} from "../redux/reducers/dataQuery";
import StoreFactory from "../redux/StoreFactory";

import DataQuery from '../components/DataQuery'
import {IStoreConfig} from "../interfaces/storeFactory";


const renderApp = () => {
    const storeConfig = {
        reducers,
        initialState,
        persistConfig: undefined
    } as IStoreConfig

    ReactDOM.render(
        <StoreFactory config={storeConfig}>
                <DataQuery />
        </StoreFactory>
        ,
        document.getElementById("react-root")
    )
}

renderApp()

